module.exports = __webpack_public_path__ + "static/img/fa-brands-400.a5a8a66.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fontawesome-5.10.2/webfonts/fa-brands-400.svg
// module id = 336
// module chunks = 1